import { useEffect, useRef, useState } from 'react';
import api from '../api';

function AddStock() {
  const [identifier, setIdentifier] = useState('');
  const [quantity, setQuantity] = useState('');
  const [entryType, setEntryType] = useState('purchase');
const [returnFunctional, setReturnFunctional] = useState(true);
  const [stockItems, setStockItems] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    fetchStock();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (!identifier.trim()) {
      setSelectedProduct(null);
      return;
    }

    const normalized = identifier.trim().toLowerCase();

    const found = stockItems.find((item) => {
      const byId = String(item.id || '').trim().toLowerCase() === normalized;
      const byBarcode = String(item.barcode || '').trim().toLowerCase() === normalized;
      const byName = String(item.productName || '').trim().toLowerCase().includes(normalized);

      return byId || byBarcode || byName;
    });

    setSelectedProduct(found || null);
  }, [identifier, stockItems]);

  const fetchStock = async () => {
    try {
      const response = await api.get('/getStock');
      setStockItems(response.data.stock || []);
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Nu am putut incarca produsele din stoc'
      );
    }
  };

  const getSuccessMessage = (type, productName, isFunctionalReturn = true) => {
    if (type === 'purchase') {
      return 'Marfa adaugata cu succes: ' + productName;
    }

    if (type === 'return') {
      return isFunctionalReturn
        ? 'Retur functional procesat cu succes: ' + productName
        : 'Retur nefunctional inregistrat cu succes: ' + productName;
    }

    if (type === 'unclaimed') {
      return 'Neridicat adaugat cu succes: ' + productName;
    }

    return 'Operatiune efectuata cu succes: ' + productName;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier.trim()) {
      setError('Scaneaza sau scrie un cod / nume produs');
      setMessage('');
      return;
    }

    if (!quantity || Number(quantity) <= 0) {
      setError('Introdu o cantitate valida');
      setMessage('');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setMessage('');

      const response = await api.post('/stockIn', {
        identifier: identifier.trim(),
        quantity: Number(quantity),
        entryType: entryType,
        returnFunctional: returnFunctional
      });

      const updatedProduct = response.data.product;

      setMessage(getSuccessMessage(entryType, updatedProduct.productName));

      setQuantity('');
      setIdentifier('');
      setSelectedProduct(null);

      await fetchStock();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 50);
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'A aparut o eroare la intrarea de marfa'
      );
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  const handleQuickOrder = async () => {
    if (!selectedProduct) {
      setError('Selecteaza mai intai un produs');
      setMessage('');
      return;
    }

    if (!quantity || Number(quantity) <= 0) {
      setError('Introdu o cantitate valida pentru comanda');
      setMessage('');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setMessage('');

      const response = await api.post('/orderSupplier', {
        identifier: selectedProduct.id,
        quantity: Number(quantity)
      });

      const updatedProduct = response.data.product;

      setMessage('Cantitatea pe drum a fost actualizata pentru ' + updatedProduct.productName);

      setQuantity('');
      setIdentifier('');
      setSelectedProduct(null);

      await fetchStock();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 50);
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'A aparut o eroare la actualizarea cantitatii pe drum'
      );
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageStyle}>
      <h1 style={titleStyle}>Intrare marfa</h1>
      <p style={subtitleStyle}>
        Scaneaza codul de bare, codul produsului sau scrie numele produsului.
        La receptie, stocul creste. Daca alegi "Marfa receptionata", se scade si din "Pe drum".
      </p>

      <div style={gridStyle}>
        <div style={cardStyle}>
          <form onSubmit={handleSubmit}>
            <label style={labelStyle}>Cod de bare / cod produs / nume produs</label>
            <input
              ref={inputRef}
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Scaneaza sau cauta produsul"
              style={inputStyle}
            />

            <label style={labelStyle}>Cantitate</label>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              placeholder="Ex: 5"
              style={inputStyle}
            />

            <label style={labelStyle}>Tip intrare</label>
            <div style={radioWrapStyle}>
              <label style={radioLabelStyle}>
                <input
                  type="radio"
                  name="entryType"
                  value="purchase"
                  checked={entryType === 'purchase'}
                  onChange={(e) => setEntryType(e.target.value)}
                />
                <span>Marfa receptionata</span>
              </label>

              <label style={radioLabelStyle}>
                <input
                  type="radio"
                  name="entryType"
                  value="return"
                  checked={entryType === 'return'}
                  onChange={(e) => setEntryType(e.target.value)}
                />
                <span>Retur</span>
{entryType === 'return' && (
<div style={{marginTop:'15px',padding:'10px',border:'1px solid #ccc'}}>
<b>Produs returnat este functional?</b>

<label style={{display:'block',marginTop:'10px'}}>
<input
type="radio"
checked={returnFunctional===true}
onChange={()=>setReturnFunctional(true)}
/>
 Functional (adauga in stoc)
</label>

<label style={{display:'block',marginTop:'10px'}}>
<input
type="radio"
checked={returnFunctional===false}
onChange={()=>setReturnFunctional(false)}
/>
 Defect (nu adauga in stoc)
</label>

</div>
)}

              </label>

              <label style={radioLabelStyle}>
                <input
                  type="radio"
                  name="entryType"
                  value="unclaimed"
                  checked={entryType === 'unclaimed'}
                  onChange={(e) => setEntryType(e.target.value)}
                />
                <span>Neridicat</span>
              </label>

              {entryType === 'return' && (
                <div
                  style={{
                    marginTop: '14px',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '10px',
                    background: '#f9fafb'
                  }}
                >
                  <div style={{ fontWeight: 700, marginBottom: '8px' }}>
                    Produsul returnat este functional?
                  </div>

                  <label style={{ ...radioLabelStyle, marginRight: '18px' }}>
                    <input
                      type="radio"
                      name="returnFunctional"
                      checked={returnFunctional === true}
                      onChange={() => setReturnFunctional(true)}
                    />
                    <span>Da, adauga in stoc</span>
                  </label>

                  <label style={radioLabelStyle}>
                    <input
                      type="radio"
                      name="returnFunctional"
                      checked={returnFunctional === false}
                      onChange={() => setReturnFunctional(false)}
                    />
                    <span>Nu, nu adauga in stoc</span>
                  </label>
                </div>
              )}
            </div>

            <div style={buttonRowStyle}>
              <button type="submit" disabled={loading} style={buttonStyle}>
                {loading ? 'Se proceseaza...' : 'Confirma intrarea'}
              </button>

              <button
                type="button"
                disabled={loading}
                onClick={handleQuickOrder}
                style={secondaryButtonStyle}
              >
                Marcheaza ca pe drum
              </button>
            </div>
          </form>

          {message ? <div style={successStyle}>{message}</div> : null}
          {error ? <div style={errorStyle}>{error}</div> : null}
        </div>

        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Produs selectat</h2>

          {!selectedProduct ? (
            <div style={emptyStyle}>Nu este selectat niciun produs.</div>
          ) : (
            <div style={infoBoxStyle}>
              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Cod produs:</span>
                <span>{selectedProduct.id}</span>
              </div>

              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Nume produs:</span>
                <span>{selectedProduct.productName}</span>
              </div>

              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Cod de bare:</span>
                <span>{selectedProduct.barcode || '-'}</span>
              </div>

              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Stoc actual:</span>
                <span>{selectedProduct.quantity}</span>
              </div>

              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Pe drum:</span>
                <span>{selectedProduct.inTransit || 0}</span>
              </div>

              <div style={infoRowStyle}>
                <span style={infoLabelStyle}>Prag minim:</span>
                <span>{selectedProduct.minStock || 0}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={cardStyle}>
        <h2 style={sectionTitleStyle}>Produse existente in stoc</h2>

        <div style={tableWrapStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Cod produs</th>
                <th style={thStyle}>Nume produs</th>
                <th style={thStyle}>Stoc</th>
                <th style={thStyle}>Pe drum</th>
                <th style={thStyle}>Cod de bare</th>
              </tr>
            </thead>
            <tbody>
              {stockItems.length === 0 ? (
                <tr>
                  <td style={tdStyle} colSpan="5">
                    Nu exista produse in stoc.
                  </td>
                </tr>
              ) : (
                stockItems.map((item) => (
                  <tr key={item.id}>
                    <td style={tdStyle}>{item.id}</td>
                    <td style={tdStyle}>{item.productName}</td>
                    <td style={tdStyle}>{item.quantity}</td>
                    <td style={tdStyle}>{item.inTransit || 0}</td>
                    <td style={tdStyle}>{item.barcode || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const pageStyle = {
  maxWidth: '1400px',
  margin: '0 auto'
};

const titleStyle = {
  marginBottom: '8px',
  fontSize: '32px',
  color: '#111827'
};

const subtitleStyle = {
  marginTop: 0,
  marginBottom: '20px',
  color: '#4b5563'
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
  gap: '20px',
  marginBottom: '20px'
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
  color: '#111827'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '16px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  marginBottom: '14px',
  boxSizing: 'border-box'
};

const radioWrapStyle = {
  display: 'flex',
  gap: '16px',
  marginBottom: '16px',
  flexWrap: 'wrap'
};

const radioLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontWeight: '600',
  color: '#111827'
};

const buttonRowStyle = {
  display: 'flex',
  gap: '12px',
  flexWrap: 'wrap'
};

const buttonStyle = {
  background: '#2563eb',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const secondaryButtonStyle = {
  background: '#111827',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const successStyle = {
  background: '#dcfce7',
  color: '#166534',
  padding: '12px 16px',
  borderRadius: '10px',
  marginTop: '16px',
  fontWeight: '600'
};

const errorStyle = {
  background: '#fee2e2',
  color: '#991b1b',
  padding: '12px 16px',
  borderRadius: '10px',
  marginTop: '16px',
  fontWeight: '600'
};

const sectionTitleStyle = {
  marginTop: 0,
  marginBottom: '16px',
  color: '#111827'
};

const emptyStyle = {
  color: '#6b7280'
};

const infoBoxStyle = {
  display: 'grid',
  gap: '10px'
};

const infoRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '12px',
  borderBottom: '1px solid #e5e7eb',
  paddingBottom: '8px'
};

const infoLabelStyle = {
  fontWeight: '700',
  color: '#111827'
};

const tableWrapStyle = {
  overflowX: 'auto'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse'
};

const thStyle = {
  textAlign: 'left',
  padding: '12px',
  background: '#f3f4f6',
  borderBottom: '1px solid #e5e7eb',
  color: '#111827',
  fontSize: '14px'
};

const tdStyle = {
  padding: '12px',
  borderBottom: '1px solid #e5e7eb',
  fontSize: '14px',
  color: '#111827'
};

export default AddStock;